import { render } from "./FacturacionClientes.vue?vue&type=template&id=2083c850&scoped=true"
import script from "./FacturacionClientes.vue?vue&type=script&lang=js"
export * from "./FacturacionClientes.vue?vue&type=script&lang=js"

import "./FacturacionClientes.vue?vue&type=style&index=0&id=2083c850&scoped=true&lang=css"

import exportComponent from "D:\\GIT\\Interfaz_Colecturia\\colecturia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2083c850"]])

export default __exports__